import { constant, noop } from "lodash-es"
import { createContext, useContext } from "react"
import { TableSelectionController } from "~/shared/components/IntegratedTable/useTableSelectedEntries"

export type IntegratedTableControllerContextValue = TableSelectionController & {
  contextValueMissing?: true
}

export const IntegratedTableControllerContext =
  createContext<IntegratedTableControllerContextValue>({
    headerSelectionState: "NONE",
    isSelected: constant(false),
    onChangeMultiSelectionState: noop,
    onToggleRow: noop,
    resetSelection: noop,
    selectedEntriesCount: 0,
    selectedIds: [],
    contextValueMissing: true,
  })

export const useIntegratedTableController = () => useContext(IntegratedTableControllerContext)
